<template>
	<div>
		<!-- <div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<img src="@/assets/img/banners/banner-1.jpg" class="slide-banner" v-show="slideshow == 0"/>
				<img src="@/assets/img/banners/banner-2.jpg" class="slide-banner" v-show="slideshow == 1"/>
				<img src="@/assets/img/banners/banner-3.jpg" class="slide-banner" v-show="slideshow == 2"/>
			</div>
		</div> -->
		<div class="md-layout">
			<div class="md-layout-item md-xsmall-size-33 md-small-size-33 md-medium-size-33 md-size-33" v-for="game in game_banner">
				<router-link :to="game.route">
					<div class="game-banner">
						<img :src="'/banners/' + game.url" style="width: 80%"/>
						<span class="game-banner-title">{{$store.state.lang.text[game.title][$store.state.lang.language]}}</span>
					</div>
				</router-link>
			</div>
		</div>
		<!-- <div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<img src="@/assets/img/banners/middle-banner.jpg"  class="slide-banner" style="margin-top: 10px"/>
			</div>
		</div> -->
		<!-- <div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-medium-size-33 md-size-33">
				<div class="promotion-banner">
					<img src="@/assets/img/banners/register.png" style="width: 20%"/>
					<div style="display: flex; flex-direction: column;;margin-left: 8px">
						<span class="promotion-banner-title">{{$store.state.lang.text.open_account[$store.state.lang.language]}}</span>
						<span class="promotion-banner-sub">{{$store.state.lang.text.open_account_slogan[$store.state.lang.language]}}</span>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-medium-size-33 md-size-33">
				<div class="promotion-banner">
					<img src="@/assets/img/banners/play.png" style="width: 20%"/>
					<div style="display: flex; flex-direction: column;;margin-left: 8px">
						<span class="promotion-banner-title">{{$store.state.lang.text.game[$store.state.lang.language]}}</span>
						<span class="promotion-banner-sub">{{$store.state.lang.text.game_slogan[$store.state.lang.language]}}</span>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-medium-size-33 md-size-33">
				<div class="promotion-banner">
					<img src="@/assets/img/banners/deposit-withdraw.png" style="width: 20%"/>
					<div style="display: flex; flex-direction: column;;margin-left: 8px">
						<span class="promotion-banner-title">{{$store.state.lang.text.deposit_withdraw[$store.state.lang.language]}}</span>
						<span class="promotion-banner-sub">{{$store.state.lang.text.deposit_withdraw_slogan[$store.state.lang.language]}}</span>
					</div>
				</div>
			</div>
		</div> -->
		<div class="md-layout" style="margin: 10px 0 10px 0px;">
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<img src="@/assets/img/banners/banner-middle/banner-middle-1.jpg" v-show="slideshow == 0" style=" width: 100%;margin-top: 10px; margin-bottom: 10px;border-radius: 15px;"/>
				<img src="@/assets/img/banners/banner-middle/banner-middle-2.jpg" v-show="slideshow == 1" style=" width: 100%;margin-top: 10px; margin-bottom: 10px;border-radius: 15px;"/>
				<img src="@/assets/img/banners/banner-middle/banner-middle-3.jpg" v-show="slideshow == 2" style=" width: 100%;margin-top: 10px; margin-bottom: 10px;border-radius: 15px;"/>
				<img src="@/assets/img/banners/banner-middle/banner-middle-4.jpg" v-show="slideshow == 3" style=" width: 100%;margin-top: 10px; margin-bottom: 10px;border-radius: 15px;"/>
			</div>
		</div>
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
				<div class="video-container" style="position: relative; width: 100%;padding-bottom: 56.25%">
					<iframe style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;border: 0;border-radius: 15px;" src="https://www.youtube.com/embed/i2-EbQnNrhA?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
				</div>

			</div>
		</div>

		<div class="md-layout" style="padding: 5px 0 5px 0; border-radius: 15px; text-align: center; justify-content: center;" >
			<div class="md-layout-item md-xsmall-size-33 md-small-size-33 md-medium-size-33 md-size-15">
				<div class="trust-banner">
					<img src="@/assets/img/banners/t1.png" style="width: 30%"/>
					<span class="trust-banner-title">{{$store.state.lang.text.confidence[$store.state.lang.language]}}</span>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-33 md-small-size-33 md-medium-size-33 md-size-15">
				<div class="trust-banner">
					<img src="@/assets/img/banners/t2.png" style="width: 30%"/>
					<span class="trust-banner-title">{{$store.state.lang.text.good_service[$store.state.lang.language]}}</span>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-33 md-small-size-33 md-medium-size-33 md-size-15">
				<div class="trust-banner">
					<img src="@/assets/img/banners/t3.png" style="width: 30%"/>
					<span class="trust-banner-title">{{$store.state.lang.text.fast[$store.state.lang.language]}}</span>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-33 md-small-size-33 md-medium-size-33 md-size-15">
				<div class="trust-banner">
					<img src="@/assets/img/banners/t4.png" style="width: 30%"/>
					<span class="trust-banner-title">{{$store.state.lang.text.easy[$store.state.lang.language]}}</span>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-33 md-small-size-33 md-medium-size-33 md-size-15">
				<div class="trust-banner">
					<img src="@/assets/img/banners/t5.png" style="width: 30%"/>
					<span class="trust-banner-title">{{$store.state.lang.text.secure[$store.state.lang.language]}}</span>
				</div>
			</div>
			<div class="md-layout-item md-xsmall-size-33 md-small-size-33 md-medium-size-33 md-size-15">
				<div class="trust-banner">
					<img src="@/assets/img/banners/t6.png" style="width: 30%"/>
					<span class="trust-banner-title">{{$store.state.lang.text.confidential[$store.state.lang.language]}}</span>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';

	export default {
		components: {
		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {
			// this.$http.get(this.config.api + "/admin/get/stat").then(data => {
			// 	this.stat = data.body.data
			// 	this.loaded = true;
			// });
			// this.getToday();
			// this.getMonth();

			this.interval = setInterval(() => {
				this.slideshow = (this.slideshow + 1) % 4
			}, 4000)
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		methods: {
			getToday() {
				this.$http.get(this.config.api + "/admin/get/stat/day").then(data => {
					this.today = data.body.data
				});
			},
			getMonth() {
				this.$http.get(this.config.api + "/admin/get/stat/month").then(data => {
					this.month = data.body.data
				});
			},
			getRange() {
				let start_date = (new Date(this.start_date)).getTime();
				let end_date = (new Date(this.end_date)).getTime();

				this.$http.get(this.config.api + "/admin/get/stat/range/" + start_date + "/" + end_date).then(data => {
					this.range = data.body.data
					// this.loaded = true;
				});
			}
		},
		computed: {
		},
		data() {
			return {
				loaded: true,
				stat: {
					total_admin: 0,
					total_game: 0,
					total_provider: 0,
					total_client: 0,
					total_balance: 0,
					total_deposit: 0,
					total_withdraw: 0,
					total_bet: 0,
					total_win: 0
				},
				today: {
					total_deposit: 0,
					total_withdraw: 0,
					total_bet: 0,
					total_win: 0
				},
				month: {
					total_deposit: 0,
					total_withdraw: 0,
					total_bet: 0,
					total_win: 0
				},
				start_date: "",
				end_date: "",
				slideshow: 0,
				slide_banner: [

				],
				game_banner: [
					{title: "esport", route: "/bet/sport", url: "esport.webp"},
					{title: "casino", route: "/bet/casino", url: "casino.webp"},
					{title: "fishing", route: "/bet/fishing", url: "fishing.webp"},
					{title: "slot", route: "/bet/slot", url: "slot.webp"},
					{title: "cock_fighting", route: "/bet/cock_fighting", url: "cock.webp"},
					{title: "keno", route: "/bet/keno", url: "lotto.webp"},
					{title: "open_account", route: "/register", url: "open.webp"},
					{title: "deposit", route: "/account/deposit", url: "deposit.webp"},
					{title: "promotion", route: "/page/promotions", url: "promotions.webp"}
				],
				interval: null
			}
		}
	}
</script>
<style>
	.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}
	.slide-banner {
		border-radius: 15px;
		border: 1px solid #135F87;
	}
	.promotion-banner {
		border: 1px solid #135F87;
		border-radius: 15px;
		margin-top: 10px;
		width: 100%;
		padding: 10px;
		display: flex;
		flex-direction: row;
		justify-content: left;
		align-items: center;
		cursor: pointer;
	}
	.promotion-banner-title {
		font-size: 17px;
	}
	.promotion-banner-sub {
		font-size: 12px;
	}
	.trust-banner {
		border: 1px solid #135F87;
		border-radius: 15px;
		margin-top: 10px;
		width: 100%;
		padding: 15px 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}
	.trust-banner-title {
		margin-top: 8px;
		font-size: 12px;
	}
	.game-banner {
		border: 1px solid #135F87;
		border-radius: 15px;
		margin-top: 10px;
		width: 100%;
		padding: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}
	.game-banner-title {
		margin-top: 0px;
		font-size: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue